import { getZrmListingInfo, getZrmUserInfo, type ZrmClickstreamListing } from '@zg-rentals/clickstream';
import { trackListingEvent } from '../../analytics';
import {
  SEMANTIC_EVENT_NAME,
  TOPIC_TAG_TXT,
  TRIGGER_LOCATION,
  TRIGGER_OBJECT,
  TRIGGER_SOURCE,
  TRIGGER_TYPE,
} from './globals';
import type { ZrmClickstreamUserOrNull } from '../../analytics/types';

// https://dataportal.zillowgroup.net/event-registry/2452
export const SEND_MESSAGE_EVENT_TYPE_ID = '2452';
export const emitSendMessageEvent = (user: ZrmClickstreamUserOrNull, listing: ZrmClickstreamListing) =>
  trackListingEvent({
    envelope: {
      event_type_id: SEND_MESSAGE_EVENT_TYPE_ID,
      event_type_version_id: '1',
      event_template_id: '168',
      event_template_version_id: '1',
    },
    clickstream_trigger: {
      trigger_type_nm: TRIGGER_TYPE.Interaction,
      trigger_location_nm: TRIGGER_LOCATION.IreneInbox,
      trigger_source_nm: TRIGGER_SOURCE.SendButton,
      trigger_object_nm: TRIGGER_OBJECT.MessageWindow,
    },
    semantic: {
      semantic_event_nm: SEMANTIC_EVENT_NAME.ReplyMessage,
      topic_tag_txt: [TOPIC_TAG_TXT.ZrmSatellite],
    },
    ...getZrmUserInfo(user),
    ...getZrmListingInfo(listing),
  });

// https://dataportal.zillowgroup.net/event-registry/8432
export const emitSendDraftMessageEvent = (user: ZrmClickstreamUserOrNull, listing: ZrmClickstreamListing) =>
  trackListingEvent({
    envelope: {
      event_type_id: '8432',
      event_type_version_id: '1',
      event_template_id: '167',
      event_template_version_id: '1',
    },
    clickstream_trigger: {
      trigger_type_nm: TRIGGER_TYPE.Interaction,
      trigger_location_nm: TRIGGER_LOCATION.IreneInbox,
      trigger_source_nm: TRIGGER_SOURCE.SendButton,
      trigger_object_nm: TRIGGER_OBJECT.MessageWindow,
    },
    semantic: {
      semantic_event_nm: SEMANTIC_EVENT_NAME.ReplyMessage,
      topic_tag_txt: [TOPIC_TAG_TXT.ZrmSatellite],
    },
    ...getZrmUserInfo(user),
    ...getZrmListingInfo(listing),
  });
